import { render, staticRenderFns } from "./exchange-items.vue?vue&type=template&id=4f7b9742&scoped=true&"
import script from "./exchange-items.vue?vue&type=script&lang=js&"
export * from "./exchange-items.vue?vue&type=script&lang=js&"
import style0 from "./exchange-items.vue?vue&type=style&index=0&id=4f7b9742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7b9742",
  null
  
)

export default component.exports